define('fukit/service/app.menu.service',['require','exports','module','backbone.radio','uikit/uikit','appkit/appkit','../view/app.header.container.view'],function(require, exports, module) {
  //prettier-ignore
  var Radio          = require('backbone.radio'),
      UIKit          = require('uikit/uikit'),
      AppKit         = require('appkit/appkit'),
      AppHeaderContainerView  = require('../view/app.header.container.view');

  var AppMenuService = {
    radioEvents: {
      'app configure': 'onAppConfigure',
      'app start': 'onAppStart',
      'app ready': 'onAppReady',
    },

    options: {
      layout: AppKit.REQUIRED_OPTION,
    },

    onAppConfigure: function() {
      AppKit.mergeRadioOptions(this, 'appMenuServiceConfiguration');
    },

    onAppStart: function() {
      this.appHeaderContainerView = new AppHeaderContainerView();
    },

    onAppReady: function() {
      var layout = this.options.layout;

      layout.showChildView('header', this.appHeaderContainerView);
    },
  };

  module.exports = AppMenuService;
});

